const activePanelClass = "js-active";

const getCorrectTabPanelGroup = (tabGroupId) => {

    const allTabPanelGroups = document.querySelectorAll("#tab-panel-group-" + tabGroupId)
     
    for(const tabPanelGroup of allTabPanelGroups) {

        const tabGroupButtonList = tabPanelGroup.querySelector(".tab-group__button-list")
        const panels = tabPanelGroup.querySelectorAll(".tab-panel")
        const firstPanel = tabPanelGroup.querySelector(".tab-panel")
        const arrayOfActivePanels = [];
        
        //create an array of active panels if match anchor 
        for (const anchorPanel of panels) {
            const isAnchorURLConditionTrue = anchorPanel.dataset.tabAnchorId === activeTabFromUrlAnchor();
            if (isAnchorURLConditionTrue) {
                arrayOfActivePanels.push(true)
            }
        }

        //redo once array has been created.
        for (const [index, panel] of panels.entries()) {
            
            //console.log('activeTabFromUrlAnchor', activeTabFromUrlAnchor())
            panel.style.display = "none"; //initial display of all panels except active
            panel.classList.remove(activePanelClass)

            const panelTitle = panel.dataset.tabPanelTitle
            const panelId = panel.dataset.tabPanelId
            const isAnchorURLConditionTrue = panel.dataset.tabAnchorId === activeTabFromUrlAnchor();
            
            let isActiveOnStartConditionTrue = panel.dataset.tabActiveOnStart === "true" && index !== 0;

            //console.log('conditions', arrayOfActivePanels)
            //check to to see if anchor panels exist on page load and if so then stop the normal selected panel
            if (!!arrayOfActivePanels.length) {
                isActiveOnStartConditionTrue = false
            }
            
            let buttonActiveOnInit = isActiveOnStartConditionTrue || isAnchorURLConditionTrue ? activePanelClass : ''
            tabGroupButtonList.appendChild(buildTabButtonElement(panelTitle, panelId, buttonActiveOnInit));
        

            //start first panel active
            if (index === 0) {       
                panel.style.display = "block"
                panel.classList.add(activePanelClass)
            }

            
            //start with selected tab
            if (isActiveOnStartConditionTrue || isAnchorURLConditionTrue) {
                firstPanel.style.display = "none"
                firstPanel.classList.remove(activePanelClass)     
                panel.style.display = "block"
                panel.classList.add(activePanelClass)
            }

            //Scroll to anchor 
            if (isAnchorURLConditionTrue) {
                panel.scrollIntoView({behavior:"smooth", block: "center" })
            }

            //console.log('arrayOfActivePanels', arrayOfActivePanels)
            
        }
        
    }
}

const buildTabButtonElement = (buttonText, tabGroupId, buttonActiveOnInit) => {

    const button = document.createElement("button");
    button.setAttribute("data-tab-panel-id", tabGroupId);
    button.classList.add("tab-panel-button");
    button.innerText = buttonText;

    if (buttonActiveOnInit.length) {
        
        button.classList.add(activePanelClass)
    }

    return button;
}

//Now Document has built the buttons for the panels
const setTabButtonAction = (tabGroupId) => {

    const specificGroup = "#tab-panel-group-" + tabGroupId
    const buttonGroup = specificGroup + " .tab-panel-button"
    const tabPanels = document.querySelectorAll(specificGroup + " .tab-panel")
    const buttons = document.querySelectorAll(buttonGroup);
    const firstButton = document.querySelector(buttonGroup);
    
    for (const[index, button]  of buttons.entries()) {

        //init first button active
        if (index === 0) {           
            button.classList.add(activePanelClass)
        }
        //Unless other panel is selected to open with
        if (button.classList.contains(activePanelClass) && index !== 0) {
            firstButton.classList.remove(activePanelClass)
        }



        button.addEventListener("click", (event) => {

            //Find and reset any active class on buttons
            const existingActiveButton = document.querySelector(buttonGroup+"."+activePanelClass);
            existingActiveButton?.classList.remove(activePanelClass);
            
            for (const panel of tabPanels) {

                //reset the panel
                panel.classList.remove(activePanelClass);
                panel.style.display = "none";

                if (panel.dataset.tabPanelId === event.target.dataset.tabPanelId) {

                    panel.classList.add(activePanelClass);
                    event.target.classList.add(activePanelClass);
                    panel.style.display = "block";
                }
            }
        })
    }
}
//If there is an anchor link that matches a tab then provide this.
function activeTabFromUrlAnchor() {
    
    const pageUrlAnchorHash = window.location.hash
    const stripHashFromId = pageUrlAnchorHash.replace("#", "");

    let tabPanelAnchorID = null; //make sure not just empty string
    
    if (pageUrlAnchorHash) {
        
        tabPanelAnchorID  = stripHashFromId
    } 

    return tabPanelAnchorID;
}

//Used on the PHP template to pass in UID per tab group on the page.
function initialiseTabGroup(tabGroupId) {
    
    //wait for the DOM to be loaded
    getCorrectTabPanelGroup(tabGroupId)
    setTabButtonAction(tabGroupId)
    activeTabFromUrlAnchor(tabGroupId)

}
document.addEventListener("DOMContentLoaded", () => { 

    const tabGroups = document.querySelectorAll(".tab-group");

    for (const tabGroup of tabGroups) { 


        const tabGroupId = tabGroup.dataset.tabGroupId;
        initialiseTabGroup(tabGroupId)
    }
})
